import { func, string, bool, shape } from 'prop-types';
import DateInputs from '../../shared/Date';
import Input from '../../shared/Input';
import { Stack, FormStack } from '../../shared/layouts';
import RadioButton from '../../shared/RadioButton';
import Card from '../../shared/Card';
import Header from '../../shared/Header';
import RemoveIcon from 'imagesUwKluis/svg/close.svg';
import LonelyPlaceholder from '../../shared/LonelyPlaceholder';
import i18n from "../../../i18n";
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../hooks/useIconLibrary";

export const getGenderOptions = () => [
  { value: 'male', label: i18n.t('Man')},
  { value: 'female', label: i18n.t('Vrouw')},
];

const PersonSection = ({
  handleChange,
  initials,
  firstname,
  addition,
  lastname,
  date_of_birth,
  aow_date,
  gender,
  child,
  onRemove,
  errors,
  partner,
  readOnly,
  FormFiller,
}) => {
  const { t } = useTranslation();
  const { ProfileIcon } = useIconLibrary();

  return (
    <Card>
      <Stack space="m" width="100%">
        <Header
          title={t('Persoonsgegevens') + (partner ? ' ' + t('partner') : '')}
          icon={<ProfileIcon height="2rem" width="2rem" />}
          button={
            child && !readOnly ? (
              <RemoveIcon
                css={({ colors }) => ({
                  fill: colors?.alert || 'red',
                  cursor: 'pointer',
                  margin: '0.25rem',
                })}
                width="1.5rem"
                height="1.5rem"
                onClick={onRemove}
              />
            ) : null
          }
          variant="section"
        />
        <FormStack space="m" readOnly={readOnly}>
          {/* Row */}
          <RadioButton
            label={t("Geslacht")}
            direction={'row'}
            autoFocus={!partner}
            value={gender}
            name={`${partner ? 'partner_' : ''}gender`}
            options={getGenderOptions()}
            onChange={(value) =>
              handleChange({ target: { name: 'gender', value } })
            }
            readOnly={readOnly}
          />
          <FormFiller />
          {/* Row */}

          <Input
            label={t("Initialen")}
            name="initials"
            value={initials}
            onChange={handleChange}
            errors={errors.initials}
            readOnly={readOnly}
          />
          <Input
            label={t("Voornaam")}
            name="firstname"
            value={firstname}
            onChange={handleChange}
            errors={errors.firstname}
            readOnly={readOnly}
          />
          {/* Row */}
          <Input
            label={t("Tussenvoegsel")}
            name="addition"
            value={addition}
            onChange={handleChange}
            errors={errors.addition}
            readOnly={readOnly}
          />
          <Input
            label={t("Achternaam")}
            name="lastname"
            value={lastname}
            onChange={handleChange}
            errors={errors.lastname}
            readOnly={readOnly}
          />
          {/* Row */}
          <DateInputs
            label={t("Geboortedatum")}
            name="date_of_birth"
            value={date_of_birth}
            onChange={handleChange}
            errors={errors['date_of_birth']}
            readOnly={readOnly}
          />
          <DateInputs
            label={t("AOW-datum")}
            name="aow_date"
            value={aow_date}
            onChange={handleChange}
            errors={errors['aow_date']}
            readOnly={readOnly}
          />
          <FormFiller />
          <LonelyPlaceholder />
        </FormStack>
      </Stack>
    </Card>
  );
}

PersonSection.propTypes = {
  handleChange: func,
  initials: string,
  firstname: string,
  addition: string,
  lastname: string,
  date_of_birth: string,
  gender: string,
  child: bool,
  onRemove: func,
  errors: shape({}),
};

PersonSection.defaultProps = {
  child: false,
  errors: {},
};

export default PersonSection;
